<template>
  <CloseHeader :title="`${t('support_center')}`" />
  <div class="app-container">
    <h1 class="app-tit">{{ t('ss_title_faq') }}</h1>

    <div class="faq-wrap">
      <FaqCategory :category="t('ss_title_subscription_account')" :qna-list="ACCOUNT_SUBSCRIPTION_QNA" />
      <FaqCategory :category="t('label_interpretation')" :qna-list="INTERPRETATION_QNA" />
    </div>

    <!-- 문의하기 -->
    <!-- <div class="faq-contact-wrap">
      <div class="tit pdb-3">
        <img :src="'/public/icons/contact.svg'" alt="" />
        <p>문의하기</p>
      </div>
      <div class="basic-select pdb-2">
        <select class="l-select" name="" id="">
          <option value="" disabled selected hidden>문의 카테고리를 선택해주세요</option>
          <option value="">서비스 이용</option>
          <option value="">계정 및 결제</option>
          <option value="">문제 해결</option>
          <option value="">서비스 개선 제안</option>
          <option value="">제휴 문의</option>
          <option value="">기타</option>
        </select>
      </div>
      <textarea class="app-textarea" name="" id=""></textarea>
      <button type="button" class="m-btn btn-primary mt-4">문의하기</button>
    </div> -->
  </div>
</template>

<script setup lang="ts">
import CloseHeader from '@/components/domains/mobile/common/CloseHeader.vue';
import FaqCategory from '@/components/domains/mobile/user-manage/FaqCategory.vue';
import { ACCOUNT_SUBSCRIPTION_QNA, INTERPRETATION_QNA } from '@/utils/constants/qna';

const { t } = useI18n();
</script>

<style scoped lang="scss">
.app-tit {
  padding-top: 1rem;
}
.app-container {
  padding-bottom: 6rem;
}

.faq-contact-wrap {
  width: 100%;
  .tit {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: $size-s;
  }
}
</style>
